export default "__VITE_ASSET__BkVgGwTv__"